import React from "react";
import "./GlobalModal.css"; // You'll create this CSS file

const GlobalModal = ({
  open,
  setOpen,
  children,
  isFullScreen = false,
  disableOutsideClick = false,
}: IGlobalModal) => {
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  if (!open) return null;

  return (
    <div className="global-modal-backdrop">
      <div
        className={`global-modal-container ${isFullScreen ? "fullscreen" : ""}`}
        onClick={stopPropagation}
      >
        <button className="close-button" onClick={() => setOpen(false)}>
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default GlobalModal;
